export default class ImageHelper {
  /**
   *
   * Модификации svg, на вход получает весь код картинки в виде string.
   * @param code - <svg>...</svg>
   * @param values - пары название аттрибута и значение, например { fill: 'white', stroke: 'black' }
   */
  static preProcessor = (code: string, values: Record<string, string>) => {
    let newCode = code;

    Object.entries(values).forEach(([key, value]) => {
      const regex = new RegExp(`${key}="(?!none").*?"`, 'g');

      newCode = newCode.replace(regex, `${key}="${value}"`);
    });

    return newCode;
  };
}
